import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MDButton from "components/MDButton";
import { SectionHeader, ranuOutlinedButtonSx, useAccent } from "./SectionCard";

// Same header as the other pages (e.g. View Blog): Back button + badge + short description
const ReceiptHeader = () => {
  const navigate = useNavigate();
  const { accentName } = useAccent();

  return <SectionHeader icon="receipt_long" label="RECEIPT" />;
};

export default ReceiptHeader;
